module.exports = __webpack_public_path__ + "static/media/Services - Separator.0266ae00.svg";